import { gsap } from 'gsap';
function Animate(
  sprite,
  {
    duration = 1,
    speed = 1,
    ease = 'Cubic.easeIn',
    canvasWidth,
    isBackground,
    index,
    isMask,
    Textsprite,
    SubSceneContainer,
    textLength,
    isTemplate,
    entrySpeedArray,
  }
) {
  if (isBackground) {
    if (isMask) {
      SubSceneContainer.addChild(sprite);
      Textsprite.mask = sprite;
    }
    let finalWidh = sprite.width;
    sprite.width = 0.1;
    let delay = 0;
    if (isTemplate && index && entrySpeedArray && entrySpeedArray.length > 0) {
      for (let u = 0; u < index; u++) {
        delay = delay + entrySpeedArray[u];
      }
    } else if (isTemplate && index) {
      delay = index * (duration * speed);
    }
    var animation = gsap.to(sprite, {
      width: finalWidh,
      duration: duration * speed,
      ease: 'steps(' + textLength + ')',
      delay: delay,
      paused: true,
    });
    return animation;
  } else {
    return null;
  }
}
export default { Animate };

// import { gsap } from "gsap";
// function Animate(sprite,  { duration= 1,speed=1, ease= 'Cubic.easeIn',canvasWidth }) {
//     var finalx= sprite.x;
//     sprite.x =  -(canvasWidth-sprite.x);
//     var animation=gsap.to(sprite, { x: finalx, duration: (duration*speed),ease: "steps(40)", paused:true });
//     return animation;
// }
// export default { Animate };
